import { Injectable, inject } from '@angular/core';
import {  CrudService } from '@shared/modules/crud/crud.service';
import { OccupancyRole } from './consorcistas.service';
import { Timestamp } from '@angular/fire/firestore';




export type CocheraConsorcista = {
    uid?: string;
    nivel:string;
    numero:number;
    //etiqueta de la cochera en la estructura del consorcio al momento de guardar (si tiene). La identidad sigue siendo nivel + numero
    label?:string;
    createdAt: Date | Timestamp;
    consorcioId: string;
    occupancyRole?: OccupancyRole;
    firstName: string;
    lastName: string;
    countryCode?: string;
    phoneArea: string;
    phoneNumber: string | number;
    consorcistaId?: string;
}

export type CocheraConsorcistaPending = CocheraConsorcista & { status: 'pending' | 'accepted' | 'rejected', wspId: string; };



@Injectable({
    providedIn: 'root',
})
export class CocherasService {
    crudService = inject(CrudService);
    subcollection = 'cocheras';

    create(consorcioId: string,consorcistaId:string, data: CocheraConsorcista) {
        const path = 'consorcios/' + consorcioId + '/consorcistas/' + consorcistaId + '/' + this.subcollection;
        this.crudService.setModel(path);
        return this.crudService.add(data);
    }
    

    update(consorcioId: string,consorcistaId:string, data: Partial<CocheraConsorcista>) {
        const path = 'consorcios/' + consorcioId + '/consorcistas/' + consorcistaId + '/' + this.subcollection;
        this.crudService.setModel(path);
        return this.crudService.update('', data);
    }

    updatePending(consorcioId: string, id:string, data: Partial<CocheraConsorcistaPending>) {
        const path = 'consorcios/' + consorcioId + '/cocherasPendientes/' + id;
        this.crudService.setModel(path);
        return this.crudService.update('', data);
    }

    getConsorcistaById(consorcioId: string,consorcistaId:string,id:string) {
        const path = 'consorcios/' + consorcioId + '/consorcistas/' + consorcistaId + '/' + this.subcollection + '/' + id;
        this.crudService.setModel(path);
        return this.crudService.findFirst<any>('');
    }
    //todas las cocheras de un consorcista
    getByConsorcistaId(consorcioId: string,consorcistaId:string) {
        const path = 'consorcios/' + consorcioId + '/consorcistas/' + consorcistaId + '/' + this.subcollection;
        this.crudService.setModel(path);
        return this.crudService.findAll<any>();
    }

    getAllPending(consorcioId: string) {
        const path = 'consorcios/' + consorcioId + '/cocherasPendientes';
        this.crudService.setModel(path);
        return this.crudService.findAll<any>();
    }

    getAllPendingByConsorcista(consorcioId: string, consorcistaId:string){
        const path = 'consorcios/' + consorcioId + '/consorcistasPendientes/' + consorcistaId + '/' + this.subcollection;
        this.crudService.setModel(path);
        return this.crudService.findAll<any>();
    }

    delete(consorcioId: string, consorcistaId: string, id: string) {
        const path = 'consorcios/' + consorcioId + '/consorcistas/' + consorcistaId + '/' + this.subcollection + '/' + id;
        this.crudService.setModel(path);
        return this.crudService.delete('');
    }
    
    /* la busqueda por nombre del consorcista, tanto dueño como inquilino, debe aplicarse despues con un pipe */
    search(filter:{consorcioId: string, nivel?:string, numero?:number, consorcistaId?:string}){
        const path =this.subcollection;
        this.crudService.setModel(path);

        const filters:any =[
            {
                field: 'consorcioId',
                operator: '==',
                value: filter.consorcioId,
            },
        ];

        if(filter.nivel){
            filters.push({
                field: 'nivel',
                operator: '==',
                value: filter.nivel,
            });
        }

        if(filter.numero){
            filters.push({
                field: 'numero',
                operator: '==',
                value: filter.numero,
            });
        }

        if(filter.consorcistaId){
            filters.push({
                field: 'consorcistaId',
                operator: '==',
                value: filter.consorcistaId,
            });
        }
        
        return this.crudService.searchCollectionGroupMany<any>(filters,[{
                orderBy: 'createdAt',
                orderByDirection: 'desc',
            },
            {
                orderBy: 'nivel',
                orderByDirection: 'asc',
            },
            {
                orderBy: 'numero',
                orderByDirection: 'asc',
            },
            {
                orderBy: 'consorcistaId',
                orderByDirection: 'asc',
            }
        ]);
    }
    searchCount(filter:{consorcioId: string, nivel?:string, numero?:number, consorcistaId?:string}){
        
        const path =this.subcollection;
        this.crudService.setModel(path);

        const filters:any =[
            {
                field: 'consorcioId',
                operator: '==',
                value: filter.consorcioId,
            },
        ];

        if(filter.nivel){
            filters.push({
                field: 'nivel',
                operator: '==',
                value: filter.nivel,
            });
        }

        if(filter.numero){
            filters.push({
                field: 'numero',
                operator: '==',
                value: filter.numero,
            });
        }

        if(filter.consorcistaId){
            filters.push({
                field: 'consorcistaId',
                operator: '==',
                value: filter.consorcistaId,
            });
        }
        return this.crudService.findWhereGroupCount(filters,[{
                orderBy: 'createdAt',
                orderByDirection: 'desc',
            },
            {
                orderBy: 'nivel',
                orderByDirection: 'asc',
            },
            {
                orderBy: 'numero',
                orderByDirection: 'asc',
            },
            {
                orderBy: 'consorcistaId',
                orderByDirection: 'asc',
            }
        ]);
    }

    getAllByConsorcio(consorcioId: string) {
        const path =this.subcollection;
        this.crudService.setModel(path);

        const filters:any =[
            {
                field: 'consorcioId',
                operator: '==',
                value: consorcioId,
            },
        ];
         return this.crudService.searchCollectionGroupMany<any>(filters,[{
                orderBy: 'createdAt',
                orderByDirection: 'desc',
            }
        ]);
    }


    

}
